<div class="row no-gutters view-wrapper" [ngClass]="{'sidebar-visible':sidebar=='Visible',
'sidebar-hidden':sidebar=='Hidden','sidebar-float':sidebar=='Float'}">
  <div class="col-chart col">
    <div class="chart-container" *ngIf="_isTranslationReady">
      <!-- a11y (WCAG 2.4.3 Focus Order): the chart plot area is FIRST in the DOM
           so Tab lands on the chart itself before any of the (absolutely
           positioned) toolbar buttons. Tab then moves through the buttons in
           visual order: Roll Up → Reset Zoom → Params → Export. Button screen
           position is fixed by CSS, so DOM order does not affect the layout. -->
      <div echarts
        #chartEl
        tabindex="0"
        role="application"
        [attr.aria-label]="'plan.chart.ariaLabel' | translate"
        class="chart-el"
        [options]="chartOptions"
        [merge]="chartMergeOptions"
        (chartInit)="onChartInit($event)"
        (blur)="onChartBlur()"
        (keydown.tab)="onChartTabForward($event)"
        style="width: 100%; height: 100%; display: block;"
      ></div>
      <div class="sr-only" role="status" aria-live="polite">{{ liveAnnouncement }}</div>
      <button *ngIf="viewMode=='WEEK' && displayHeader" type="button" class="btn btn-link btnRollUp" (click)="onRollUp()">
        {{'chart.btn.monthly.view' | translate}}
      </button>
      <button *ngIf="viewMode=='DAY' && displayHeader" type="button" class="btn btn-link btnRollUp" (click)="onRollUp()">
        {{'chart.btn.weekly.view' | translate}}
      </button>
      <button *ngIf="isZoomed" type="button" class="btn btn-sm btn-outline-secondary btnResetZoom" (click)="resetZoom()">
        {{resetZoomText}}
      </button>
      <button type="button" class="btnParams" (click)="onDisplayParams()"
              [attr.aria-label]="'chart.btn.show.params' | translate"
              title="{{'chart.btn.show.params' | translate}}">
        <esp-icon name="sliders-horizontal"></esp-icon>
      </button>
      <button type="button" class="btnExport" #exportToggle (click)="toggleExportMenu()"
              (keydown.arrowdown)="openExportMenu($event)"
              aria-haspopup="menu" [attr.aria-expanded]="showExportMenu"
              [attr.aria-label]="exportLabels.contextButtonTitle || ''"
              [title]="exportLabels.contextButtonTitle || ''">
        <esp-icon name="download"></esp-icon>
      </button>
      <div class="chart-export-menu" *ngIf="showExportMenu" #exportMenu role="menu"
           [attr.aria-label]="exportLabels.contextButtonTitle || ''" (keydown)="onExportMenuKeydown($event)">
        <button type="button" role="menuitem" class="btn btn-sm" (click)="onExport('png')">{{exportLabels.downloadPNG}}</button>
        <button type="button" role="menuitem" class="btn btn-sm" (click)="onExport('jpeg')">{{exportLabels.downloadJPEG}}</button>
        <button type="button" role="menuitem" class="btn btn-sm" (click)="onExport('svg')">{{exportLabels.downloadSVG}}</button>
        <button type="button" role="menuitem" class="btn btn-sm" (click)="onExport('pdf')">{{exportLabels.downloadPDF}}</button>
        <button type="button" role="menuitem" class="btn btn-sm" (click)="onExport('print')">{{exportLabels.printChart}}</button>
        <button type="button" role="menuitem" class="btn btn-sm" (click)="onExport('fullscreen')">{{exportLabels.viewFullscreen}}</button>
      </div>
    </div>

  </div>

</div>
